import React, { useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import typography from './typography';
import componentsOverride from './overrides';
import zIndex from './z-index';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { palette } from './palette';
interface Props {
  children: React.ReactNode;
}

const ThemeConfig = ({ children }: Props) => {
  const themeOptions = useMemo(
    () => ({
      palette,
      zIndex,
      typography,
    }),
    [],
  );

  // @ts-ignore
  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeConfig;
